import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-posexpiry',
  templateUrl: './posexpiry.component.html',
  styleUrls: ['./posexpiry.component.css']
})
export class PosexpiryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
